export interface RestApiResponseMessage {
    code: number;
    text: string;
}

export class RestApiResponse {
    public messages?: RestApiResponseMessage[];

    /**
     * @deprecaded just skip it unless needs parity with PHP implementation
     */
    public success?: boolean;

    constructor(data: Partial<RestApiResponse>) {
        this.messages = data?.messages || undefined;
        this.success = data?.success;
    }
}
